import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { DataLayerCardBanner } from '@com-delta-idp/mnx-fast-action-banner';
import { PartnerAnalytics } from '@com-delta-idp/mnx-skymiles-partners';
import {
  AnalyticsClick,
  Card,
  RelatedLinksAnalytics,
  SummaryAnalyticsEvent
} from '@com-delta-idp/mnx-skymiles-shared';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import { AnalyticsEvent } from '../../models/analytics-event.interface';
import { Banner, Earns } from './models/earns.interfaces';
@Component({
  selector: 'idp-earns',
  templateUrl: './earns.component.html',
  styleUrls: ['./earns.component.scss']
})
export class EarnsComponent implements OnChanges {
  @Input() content: Earns = {} as Earns;
  @Output() openLink = new EventEmitter<string>();
  @Output() analyticsEvent = new EventEmitter<SummaryAnalyticsEvent>();
  @Output() clickAnalyticsEvent = new EventEmitter<AnalyticsClick>();
  @Output() fastActionBannerClick = new EventEmitter<AnalyticsEvent>();

  displaySecondaryHeader = true;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content'].currentValue.banner.loaded) {
      this.updateDataLayer(changes['content'].currentValue.banner);
    }
  }

  handleOffersClick(data: Card) {
    const index = this.content.offers.cards.findIndex(
      (card) => card.id === data.id
    );
    if (index >= 0) {
      const analyticsData: AnalyticsClick = {
        id: this.content.offers.cards[index].id as string,
        type: 'tile',
        position: index + 1 + ' of ' + this.content.offers.cards.length,
        source: 'page content',
        name: data.action.link.label,
        sub_type: 'award',
        image: this.content.offers.cards[index].image.src,
        title: this.content.title
      };
      this.clickAnalyticsEvent.emit(analyticsData);
    }
  }

  handlePartnersClick(data: PartnerAnalytics) {
    const analyticsData: AnalyticsClick = {
      id: data.id,
      type: 'tile',
      position: data.index + 1 + ' of ' + data.length,
      source: 'page content',
      name: data.label,
      sub_type: 'award',
      title: data.title
    };
    this.clickAnalyticsEvent.emit(analyticsData);
  }

  /** Update the data layer with default values because is not a dynamic banner  */
  updateDataLayer(offerData: Banner) {
    const path = 'idp.dataLayer.digitalData.attributes';
    const bannerData = this.createBannerData(offerData);
    this.analyticsService.updateDataLayer('cardBanner', bannerData, path);
    this.triggerUIActions();
  }

  private createBannerData(offerData: Banner): DataLayerCardBanner {
    return {
      applicationStatus: offerData.offer ? 'notApproved' : '',
      cardType: offerData.offer ? (offerData.offer.cardType as string) : '',
      offerId: offerData.offer
        ? (offerData.offer.cardType as string)
        : 'default'
    };
  }

  triggerUIActions() {
    this.analyticsService.dispatchCustomEvent('amex:fab:ready', {});
  }

  onAnalyticsEvent(event: RelatedLinksAnalytics): void {
    this.analyticsEvent.emit({
      action: event.action,
      eventType: event.eventType
    });
  }

  redirect(link: string) {
    // Emit analytics event
    const eventData = {
      id: 'amexbanner',
      name: this.content.title || 'Fast Action Banner',
      position: 1,
      link: link
    };

    this.fastActionBannerClick.emit({
      eventName: 'fast_action_banner_click',
      eventData: JSON.stringify(eventData)
    });

    // Keep existing redirect functionality
    this.openLink.emit(link);
  }
}
